// Signature journey data — shared across home & journeys pages
export const JOURNEYS = [
  {
    slug: 'private-table',
    number: '01',
    name: 'The Private Table Journey',
    short: 'A privately hosted evening of aperitifs, tastings, chef’s table dining, and elegant surprises.',
    long:
      'A refined food and wine experience designed around your tastes, occasion, and preferred style of dining. Begin with a private arrival aperitif, move through a behind-the-scenes tasting, and continue to a chef’s table dinner with sommelier pairing before a final indulgence.',
    bestFor: 'Anniversaries, birthdays, luxury travellers, visiting couples, VIP guests',
    duration: '3–5 hours',
    guests: '2–6',
    investment: 'from $1,200 per couple',
    image: '/assets/photos/romantic-table.jpg',
  },
  {
    slug: 'cellar-table',
    number: '02',
    name: 'The Cellar & Table Experience',
    short: 'A wine-led culinary experience featuring private tastings, paired dining, and sommelier-style hosting.',
    long:
      'A sommelier-led journey through premium wine, paired dining, private tastings and rare cellar selections. Includes a private wine room tasting, museum-release wines, premium charcuterie or cheese pairing, multi-course dinner, and an optional take-home bottle.',
    bestFor: 'Wine lovers, executives, corporate hosting, special occasions',
    duration: '3–4 hours',
    guests: '2–8',
    investment: 'from $450 per person',
    image: '/assets/photos/wine-cellar.jpg',
  },
  {
    slug: 'estate-escape',
    number: '03',
    name: 'The Estate Escape',
    short: 'A full-day luxury journey to a premium food and wine region, with private access and chauffeured transfers.',
    long:
      'A full-day luxury culinary escape to wine country, coastal producers or artisan food regions. Includes a chauffeured luxury vehicle, private winery access, producer or farm visit, long lunch at a premium estate, scenic stops and optional helicopter transfer.',
    bestFor: 'International travellers, anniversaries, executive rewards, VIP hosting',
    duration: 'Full day',
    guests: '2–6',
    investment: 'from $1,500 per person',
    image: '/assets/photos/sedan-estate.jpg',
  },
  {
    slug: 'chef-provenance',
    number: '04',
    name: 'The Chef’s Provenance Experience',
    short: 'A seasonal produce-led experience connecting guests with makers, ingredients, and a chef-prepared meal.',
    long:
      'A produce-led journey connecting guests with seasonal ingredients, artisan makers and a chef-prepared private meal. Includes a premium market or producer visit, meet-the-maker moment, seasonal tasting, private cooking demonstration and a printed menu with ingredient notes.',
    bestFor: 'Serious food lovers, private groups, luxury travellers',
    duration: '4–5 hours',
    guests: '2–8',
    investment: 'from $650 per person',
    image: '/assets/photos/chef-plating.jpg',
  },
  {
    slug: 'bespoke',
    number: '05',
    name: 'Bespoke Culinary Concierge',
    short: 'A fully tailored culinary journey for special occasions, VIP guests, and private groups.',
    long:
      'A fully tailored culinary experience designed from the ground up — proposal dining journeys, anniversary itineraries, private chef experiences, VIP international hosting, corporate client entertainment, multi-day food and wine itineraries, and hosted restaurant booking services.',
    bestFor: 'Proposals, milestones, executive hosting, multi-day itineraries',
    duration: 'Custom',
    guests: 'By arrangement',
    investment: 'custom quoted, from $2,500',
    image: '/assets/photos/menu-card.jpg',
  },
];
